import type { IconSvgObject } from './types';

const Music01Icon: IconSvgObject = [
  ["circle", { cx: "9.49219", cy: "17", r: "4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13.4922 17V3C13.4922 5.76142 15.7308 8 18.4922 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Music01Icon;
